import { CellProps, Column } from "react-table"
import { Link } from "components/Link"
import { Status } from "components/Status"
import { ColorMap } from "utils/color"
import { ClientGroup } from "models/clientgroups"
import MoreActions from "components/MoreActions"
import { ReactComponent as DeleteIcon } from "assets/delete.svg"
import { useI18n } from "providers/I18n"
import { WithAuthority } from "components/WithAuthority"
import { MorePopover } from "components/MorePopover"
import { Authority } from "providers/A12n"

export const columns = (
  t: (k: string) => string,
  onDelete: (id: string) => void,
  hasAuthority: (allowed: Authority[]) => boolean,
): Array<
  Column<ClientGroup> & {
    header: string
    fixed?: boolean
    default: boolean
    variant?: string
    sortable?: boolean
  }
> => {
  const global_columns = [
    {
      fixed: true,
      default: true,
      align: "right",
      sortable: false,
      header: "client-groups.list.actions",
      id: "actions",
      Cell: function (props: CellProps<ClientGroup>) {
        const { id } = props.row.original
        return (
          <WithAuthority allowed={["AUTH_DELETE_CLIENT_GROUP"]}>
            <MoreActions
              options={[
                // DELETE
                {
                  label: t("client-groups.list.delete.action"),
                  icon: <DeleteIcon />,
                  onClick: () => {
                    onDelete(id)
                  },
                },
              ]}
            />
          </WithAuthority>
        )
      },
    },
  ]

  let custom_columns = [] as any
  if (!hasAuthority(["AUTH_ACCESS_GLOBAL_ADMIN"])) {
    custom_columns = global_columns
  }

  return [
    {
      fixed: true,
      default: true,
      sortable: false,
      header: "client-groups.list.name",
      id: "name",
      accessor: "name",
      Cell: function (props: CellProps<ClientGroup>) {
        const { id, name } = props.row.original
        return (
          <Link color="primary" to={`/admin-client-groups/${id}`}>
            {name}
          </Link>
        )
      },
    },
    {
      default: true,
      sortable: false,
      header: "client-groups.list.code",
      id: "code",
      accessor: "code",
    },
    {
      default: true,
      sortable: false,
      header: "client-groups.list.status",
      id: "status",
      accessor: "status",
      Cell: function (props: CellProps<ClientGroup>) {
        const { value: status } = props
        const { t } = useI18n()
        return status === null ? null : (
          <Status color={ColorMap[status]}>
            {t(`status.${status ?? ""}`)}
          </Status>
        )
      },
    },
    {
      default: true,
      sortable: false,
      header: "client-groups.list.clients",
      id: "clients",
      Cell: function (props: CellProps<ClientGroup>) {
        const { clients } = props.row.original
        const clientsToShow = clients?.slice(0, 1)?.map((c) => c?.name)
        return (
          <div>
            {clientsToShow}
            <MorePopover
              data={clients}
              label="clientgroups.clients"
              name="name"
            />
          </div>
        )
      },
    },
    ...custom_columns,
  ]
}

export const filters = []
export const sortByDefault = "name,ASC"
